<template>
  <v-layout wrap align-start>
    <v-flex xs12>
      <v-card class="card--flex-toolbar">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text"
            >Reporte de ventas y recompensas a monedero</v-toolbar-title
          >
        </v-toolbar>
        <v-container grid-list-md style="max-width: initial; padding: 20px">
          <v-layout wrap>
            <v-form>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-dialog
                    ref="dialog"
                    v-model="modal_desde"
                    :return-value.sync="filter_draft.desde"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter_draft.desde"
                        label="Desde:"
                        prepend-icon="event"
                        readonly
                        clearable
                        @click:clear="filter_draft.hasta = null"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="filter_draft.desde"
                      locale="es-MX"
                      scrollable
                    >
                      <v-spacer />
                      <v-btn color="gray" @click="modal_desde = false">
                        Cancelar
                      </v-btn>
                      <v-btn
                        color="primary"
                        @click="$refs.dialog.save(filter_draft.desde)"
                      >
                        Aceptar
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs12 md6>
                  <v-dialog
                    ref="dialog2"
                    v-model="modal_hasta"
                    :return-value.sync="filter_draft.hasta"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter_draft.hasta"
                        label="Hasta:"
                        prepend-icon="event"
                        :disabled="filter_draft.desde === null"
                        readonly
                        clearable
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="filter_draft.hasta"
                      :min="filter_draft.desde"
                      locale="es-MX"
                      scrollable
                    >
                      <v-spacer />
                      <v-btn color="gray" @click="modal_hasta = false">
                        Cancelar
                      </v-btn>
                      <v-btn
                        color="primary"
                        @click="$refs.dialog2.save(filter_draft.hasta)"
                      >
                        Aceptar
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6 d-flex>
                  <SearchClientesInput
                    @selected="filter.cliente_id = $event"
                  ></SearchClientesInput>
                </v-flex>
                <v-flex xs6 d-flex>
                  <SearchProductosInput
                    @selected="filter.producto_id = $event"
                  ></SearchProductosInput>
                </v-flex>
                <v-flex xs6 d-flex>
                  <SearchFamiliasInput
                    @selected="filter.familia_id = $event"
                  ></SearchFamiliasInput>
                </v-flex>
                <v-flex xs6 d-flex>
              <SearchSubFamiliasInput
                @selected="filter.subfamilia_id = $event"
              ></SearchSubFamiliasInput>
            </v-flex>
                <v-flex xs6 d-flex>
                  <SearchRepartidoresInput
                    @selected="filter.repartidor_id = $event"
                  ></SearchRepartidoresInput>
                </v-flex>
                <v-flex xs6 d-flex>
                  <SearchTagsInput
                    :id="true"
                    @selected="filter.tag_id = $event"
                  ></SearchTagsInput>
                </v-flex>
                <!-- <v-flex xs6 d-flex>
                                    <v-select
                                            v-model="filter_draft.user_id"
                                            :items="clientes"
                                            item-text="nombre_completo"
                                            item-value="id"
                                            :loading="loading_clientes"
                                            label="Cliente"
                                            prepend-icon="mdi-account"
                                    />
                                </v-flex> -->
                <!-- <v-flex xs6 d-flex>
                                    <v-select
                                            v-model="filter_draft.familia_id"
                                            :items="familias"
                                            item-text="nombre"
                                            item-value="id"
                                            :loading="loading_familias"
                                            label="Familia"
                                            @change="listarProductos"
                                            prepend-icon="mdi-animation"
                                    />
                                </v-flex> -->
                <!-- <v-flex xs6 d-flex>
                                    <v-select
                                            v-model="filter_draft.producto_id"
                                            :items="productos"
                                            item-text="nombre"
                                            item-value="id"
                                            :loading="loading_productos"
                                            label="Producto"
                                            prepend-icon="mdi-package-variant-closed"
                                    />
                                </v-flex> -->
                <!-- <v-flex xs6 d-flex>
                                    <v-select
                                            v-model="filter.repartidor_id"
                                            :items="repartidores"
                                            item-text="nombre_completo"
                                            item-value="id"
                                            label="Repartidor"
                                            prepend-icon="mdi-truck"
                                    />
                                </v-flex> -->
                <v-col xs="12" md="6"> </v-col>
              </v-layout>
            </v-form>
          </v-layout>
        </v-container>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            class="white--text"
            @click="exportExcel"
          >
            Exportar
          </v-btn>
          <v-btn color="blue darken-1" class="white--text" @click="sendFilter">
            Buscar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex grow pt-2>
      <v-tabs v-model="tab" icons-and-text background-color="primary">
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          Ventas
          <v-icon>mdi-point-of-sale</v-icon>
        </v-tab>

        <v-tab href="#tab-2">
          Compra de saldo
          <v-icon>mdi-cash</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="1" value="tab-1">
          <RecompensaPorPedido
            v-if="tab === 'tab-1'"
            :filter="filter"
            @export-file="filter.export = ''"
          ></RecompensaPorPedido>
        </v-tab-item>
        <v-tab-item key="2" value="tab-2">
          <RecompensaPorComprarSaldo
            v-if="tab === 'tab-2'"
            :filter="filter"
            @export-file="filter.export = ''"
          ></RecompensaPorComprarSaldo>
        </v-tab-item>
      </v-tabs-items>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RecompensaPorPedido from "@components/reportes/RecompensaPorPedido";
import RecompensaPorComprarSaldo from "@components/reportes/RecompensaPorComprarSaldo";
import SearchClientesInput from "@components/SearchClientesInput";
import SearchProductosInput from "@components/SearchProductosInput";
import SearchFamiliasInput from "@components/SearchFamiliasInput";
import SearchRepartidoresInput from "@components/SearchRepartidoresInput";
import SearchTagsInput from "@components/SearchTagsInput";
import SearchSubFamiliasInput from "@components/SearchSubfamiliasInput";
//import EventBus from "@/EventBus";

moment.locale("es");
export default {
  name: "VentasPage",
  components: {
    RecompensaPorPedido,
    RecompensaPorComprarSaldo,
    SearchClientesInput,
    SearchProductosInput,
    SearchFamiliasInput,
    SearchTagsInput,
    SearchRepartidoresInput,
    SearchSubFamiliasInput
  },
  data() {
    return {
      loading: false,
      repartidores: [],
      clientes: [],
      loading_clientes: false,
      familias: [],
      loading_familias: false,
      productos: [],
      loading_productos: false,
      filter_draft: {
        desde: null,
        hasta: null,
        recompensa_aplicada: 0,
        user_id: "",
        cliente_id: [],
        producto_id: [],
        familia_id: [],
        repartidor_id: [],
        subfamilia_id: []
      },
      filter: {
        desde: null,
        hasta: null,
        recompensa_aplicada: 0,
        user_id: "",
        cliente_id: [],
        producto_id: [],
        familia_id: [],
        subfamilia_id: [],
        repartidor_id: [],
        export: "",
        tag_id: null,
      },
      modal_desde: false,
      modal_hasta: false,
      tab: null,
      options: {
        descending: true,
        page: 1,
        itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
        totalItems: 0,
      },
    };
  },
  computed: {},
  mounted() {
    this.listarRepartidores();
    this.listarClientes();
    this.listarFamilias();
    this.listarProductos();
  },
  methods: {
    formatUpdateAt(fecha) {
      const fechaMoment = moment(fecha);

      return fechaMoment.fromNow();
    },
    sendFilter() {
      this.filter = Object.assign(this.filter, this.filter_draft);
    },
    exportExcel() {
      this.filter = Object.assign(this.filter, { export: "1" });
    },
    listarFamilias() {
      this.loading_familias = true;
      axios
        .get("/api/familia/listar", {
          params: {
            is_list: 1,
          },
        })
        .then(({ data }) => {
          this.familias = data;
          this.familias.unshift({ id: "", nombre: "Todos" });
        })
        .finally(() => {
          this.loading_familias = false;
        });
    },
    listarClientes() {
      this.loading_clientes = true;
      axios
        .get("/api/clientes/listar", {
          params: {
            is_list: 1,
          },
        })
        .then(({ data }) => {
          this.clientes = data;
          this.clientes.unshift({ id: "", nombre_completo: "Todos" });
        })
        .finally(() => {
          this.loading_clientes = false;
        });
    },
    listarProductos() {
      this.loading_productos = true;
      axios
        .get("/api/productos/listar", {
          params: {
            is_list: 1,
            familia_id: this.filter_draft.familia_id,
          },
        })
        .then(({ data }) => {
          this.productos = data.data;
          this.productos.unshift({ id: "", nombre: "Todos" });
        })
        .finally(() => {
          this.loading_productos = false;
        });
    },
    listarRepartidores() {
      axios.get("/api/usuarios/repartidores-listar").then(({ data }) => {
        this.repartidores = data;
        this.repartidores.unshift({ id: "", nombre_completo: "Todos" });
      });
    },

    filtrar() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      axios
        .get("/api/reportes/clientes/productos", {
          params: {
            sortBy: sortBy,
            sortDesc: sortDesc,
            page: page,
            rowsPerPage: itemsPerPage,
            search: this.search,
            ...this.filter,
          },
        })
        .then(({ data }) => {
          this.loading = false;
          // this.pedidos = data.data;
          this.pedidosTotal = data.total;
          this.options.page = data.current_page;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>